module.exports = __webpack_public_path__ + "img/cyber_logo.774e0d70.png";